<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="到料明细"
      width="1300px"
      top="5vh"
      class="stock-preview"
      @close="$reset('form')">
    <el-form
        ref="form"
        class="form"
        label-width="80px">
      <el-row>
        <el-table
            class="childMetrialTable"
            :data="stockDetail"
            height="75vh"
            border>
          <el-table-column prop="purchaseOrderNo" width="100" align="left" label="采购单号"/>
          <el-table-column prop="materialNo" width="100" align="left" label="物料编号"/>
          <el-table-column prop="specification" align="left" width="100" label="规格型号"/>
          <el-table-column prop="materialName" align="left" label="物料名称"/>
          <el-table-column prop="addDate" width="90" align="left" label="采购时间"/>
          <el-table-column prop="finalDeliveryDate" width="85" align="left" label="确认交期"/>
          <el-table-column prop="finalDeliveryType" align="left" label="延期原因"/>
          <el-table-column prop="finalDeliveryDesc" width="100" align="left" label="延期描述"/>
          <el-table-column prop="qty" align="center" width="80" label="采购数量"/>
          <el-table-column prop="arrivedQty" align="center" width="80" label="到料数量"/>
          <el-table-column prop="arrivedTime" align="center" width="100" label="到料时间"/>
          <el-table-column prop="sendedQuantity" align="center" width="80" label="入库数量"/>
          <el-table-column prop="createTime" align="center" width="100" label="入库时间"/>
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "MaterialStockPreview",
    data() {
      return {
        dialogVisible: false,
        stockDetail: [],
      };
    },
    computed: {},

    methods: {
      open(row, other) {
        if (other) {
          this.$http.get("basic", `taskDispatchPlan/purchaseInstock/${row}`).then(res => {
            if (res.success) {
              this.stockDetail = res.data.purchaseOrderDetailVOS;
              console.log(this.stockDetail);
            }
          }).catch(() => {
          });
        } else {
          this.stockDetail = row;
        }
        this.dialogVisible = true;
      },
    },
  };
</script>

<style lang="scss">
.stock-preview .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.stock-preview .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.stock-preview .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 10px;
  height: 90%;
}

.stock-preview .el-divider--horizontal {
  margin: 10px 0;
}

.stock-preview .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.stock-preview .childMetrialTable .el-input__inner {
  text-align: center;
}

.stock-preview .childMetrialTable .price .el-input__inner {
  text-align: left;
}
</style>